(function () {
  function hasOpenOverlay() {
    if (document.querySelector('dialog[open]')) return true;
    if (document.querySelector('details[open].menu-open')) return true;
    if (document.querySelector('.option-picker-drawer.is-open')) return true;

    var popup = document.getElementById('mystery-discount-popup');
    if (popup && popup.style.display && popup.style.display !== 'none') return true;

    return false;
  }

  function unlockStalePageScroll() {
    if (hasOpenOverlay()) return;

    document.documentElement.removeAttribute('scroll-lock');

    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }

    if (document.body.style.position === 'fixed') {
      var scrollTop = Math.abs(parseInt(document.body.style.top || '0', 10)) || window.scrollY || 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo({ top: scrollTop, behavior: 'instant' });
    }
  }

  function scheduleUnlocks() {
    unlockStalePageScroll();
    setTimeout(unlockStalePageScroll, 0);
    setTimeout(unlockStalePageScroll, 250);
    setTimeout(unlockStalePageScroll, 1000);
    setTimeout(unlockStalePageScroll, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUnlocks, { once: true });
  } else {
    scheduleUnlocks();
  }

  window.addEventListener('load', scheduleUnlocks, { once: true });
})();